import { render } from "./index.vue?vue&type=template&id=062cfe71&bindings={}"
import script from "./Home.js?vue&type=script&lang=js"
export * from "./Home.js?vue&type=script&lang=js"

import "./Home.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script